
angular.module('app.controllers', [
  'app.controllers.nav',
  'app.controllers.paginated_forms',
  'app.controllers.non-paginated-forms',
  'app.controllers.rates_and_tariffs',
  'app.controllers.alerts',
  'app.controllers.home',
  'app.controllers.history',
  'app.controllers.home',
  'app.controllers.residential',
  'app.controllers.material_specification',
  'app.controllers.how_rates_set',
  'app.controllers.accordion',
  'app.controllers.faqs',
  'app.controllers.understanding_bill',
  'app.controllers.find_a_builder',
  'app.controllers.contact',
  'app.controllers.rebates_and_promotions',
  'app.controllers.rebates_details',
  'app.controllers.contractor_referral',
  'app.controllers.referral_results',
  'app.controllers.master',
  'app.controllers.footer',
  'app.controllers.sticky_nav',
  'app.controllers.search',
  'app.controllers.squizsearch',
  'app.controllers.tab_select',
  'app.controllers.carousel',
  'app.controllers.gasmeter',
  'app.controllers.meterreading',
  'app.controllers.myaccount'
]);
